import React, { useState } from 'react';
import { formatStartTime } from '../utils/timeFormatter';
import { getStreamStatus } from '../utils/statusCalculator';
import '../styles/StreamCard.css';
import '../styles/common.css';

const StreamCard = ({ stream, index, toggleFavorite, onStreamClick, isFirstLoad, isArchiveMode }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);
  
  // ストリームのステータスを取得
  const status = getStreamStatus(stream);
  const isLive = status === 'live';

  // 開始時刻をフォーマット
  const startTime = formatStartTime(stream.startTime);
  
  // ライブ時は点滅ドット + 「ON AIR」、通常時は「開始時刻」のみ
  const timeDisplay = isLive ? 'ON AIR' : startTime;

  // カードクリック時の処理
  const handleCardClick = (e) => {
    const selection = window.getSelection();
    
    // クリックした要素が画像の場合は、テキスト選択に関わらず処理を続行
    if (e.target.tagName === 'IMG') {
      if (onStreamClick) {
        onStreamClick(stream);
      }
      return;
    }
    
    // テキスト選択中の場合はクリックイベントを無視
    if (selection && selection.toString().length > 0) {
      return;
    }
    
    if (onStreamClick) {
      onStreamClick(stream);
    }
  };

  return (
    <div 
      className={`stream-card ${isLive ? 'live' : ''} ${isFirstLoad ? 'fade-in' : ''}`} 
      onClick={handleCardClick} 
      style={{
        cursor: 'pointer',
        '--animation-delay': `${index * 0.1}s`
      }}
    >
      <div className="stream-thumbnail">
        {isImageLoading && (
          <div className="skeleton-loader" />
        )}
        <img 
          src={stream.thumbnailUrl} 
          alt={stream.title} 
          loading={index >= 3 ? "lazy" : undefined}
          onLoad={() => setIsImageLoading(false)}
          className="skeleton-image"
          style={{ 
            opacity: isImageLoading ? 0 : 1,
            transform: isImageLoading ? 'scale(0.95)' : 'scale(1)'
          }}
          draggable={true}
        />
        {!isArchiveMode && (
          <div className={`stream-time ${isLive ? 'is-live' : ''}`}>
            {isLive && <span className="live-dot" />}
            {timeDisplay}
          </div>
        )}
        {stream.channelThumbnails?.url && (
          <div className="channel-avatar">
            <img src={stream.channelThumbnails.url} alt={stream.streamer} loading={index >= 3 ? "lazy" : undefined} draggable={true} />
          </div>
        )}
      </div>
      <div className="stream-info">
        <h3 className="stream-title">{stream.title}</h3>
        <p className="stream-streamer">{stream.streamer}</p>
        <div className="stream-platform" data-platform={
          stream.platform === 'ツイキャス' ? 'twitcasting' :
          stream.platform === 'Twitch' ? 'twitch' : 'youtube'
        }>
          <img
            src={
              stream.platform === 'ツイキャス' ? '/images/platform/twitcasting.png' :
              stream.platform === 'Twitch' ? '/images/platform/twitch.png' :
              '/images/platform/youtube.png'
            }
            alt={stream.platform}
            className="platform-icon"
            draggable={false}
          />
          {stream.status === 'protected' && (
            <span className="stream-status-badge protected">プライベート配信</span>
          )}
          {stream.status === 'members_only' && (
            <span className="stream-status-badge members-only">メンバー限定</span>
          )}
        </div>
        <button 
          className={`favorite-button ${stream.isFavorite ? 'favorited' : ''}`}
          onClick={() => toggleFavorite(stream.id)}
          style={{display: 'none'}}
        >
          {stream.isFavorite ? '★' : '☆'}
        </button>
      </div>
    </div>
  );
};

export default React.memo(StreamCard);
